import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navigation.css';

function Navigation() {
  const { logout, userProfile, isAdmin } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  }

  return (
    <nav className="navigation">
      <div className="nav-brand">
        <Link to="/dashboard">
          <h2>TNF Project Hub</h2>
        </Link>
      </div>

      <div className="nav-links">
        <Link to="/dashboard" className="nav-link">Dashboard</Link>
        <Link to="/projects" className="nav-link">Projects</Link>
        <Link to="/my-projects" className="nav-link">My Projects</Link>
        
        {isAdmin && (
          <div className="nav-dropdown">
            <span className="nav-link">Admin ▾</span>
            <div className="dropdown-content">
              <Link to="/admin/projects">Manage Projects</Link>
              <Link to="/admin/chapters">Manage Chapters</Link>
            </div>
          </div>
        )}
      </div>

      <div className="nav-user">
        <span className="user-name">{userProfile?.displayName}</span>
        <button onClick={handleLogout} className="logout-button">
          Logout
        </button>
      </div>
    </nav>
  );
}

export default Navigation;
